import * as React from "react";

import { AjaxManager } from "@impero-com/common/utils/ajax";
import { t } from "@impero-com/common/utils/i18n";
import { Button } from "@impero-com/ui";

import { UserTagOverviewListDto } from "api/generated/model";
import * as theme from "org/user/userGroups/theme.css";
import { FormComponentProps, subForm } from "utils/form";

import {
    UserGroupTransferValues,
    UserListResponseOverview,
    UserTableTransfer,
} from "../members";

import { UserGroupCreatorValues } from ".";

interface UserGroupCreatorMembersStepProps extends FormComponentProps<
    "members",
    UserGroupTransferValues,
    UserGroupCreatorValues
> {
    ajaxManager: AjaxManager;
    onBack: () => void;
    onNext: () => void;
    onCancel: () => void;
    userList: UserListResponseOverview;
    allTags: UserTagOverviewListDto;
}

class UserGroupCreatorMembersStep extends React.PureComponent<UserGroupCreatorMembersStepProps> {
    render = () => {
        const { ajaxManager, form, allTags, userList } = this.props;
        const membersForm = subForm("members", form);

        return (
            <div>
                <UserTableTransfer
                    type="CREATE"
                    id="userGroupUsers"
                    allUsers={userList.data.content.map((dto) => dto.resource)}
                    allTags={allTags}
                    form={membersForm}
                    ajaxManager={ajaxManager}
                />
                <Button
                    id="user-group-manage-members-create"
                    className={theme.stepButton}
                    variant="primary"
                    onClick={this.props.onNext}
                >
                    {t("UserGroup_Create")}
                </Button>
                <Button
                    id="user-group-manage-members-back"
                    className={theme.stepButton}
                    onClick={this.props.onBack}
                    variant="primary"
                    ghost
                >
                    {t("Back")}
                </Button>
                <Button
                    id="user-group-manage-members-cancel"
                    className={theme.stepButton}
                    onClick={this.props.onCancel}
                    variant="link"
                >
                    {t("Cancel")}
                </Button>
            </div>
        );
    };
}

export { UserGroupCreatorMembersStep };
